/**
 * In react-dnd, the id property is a simple string.
 * This utility provides a way to make it type-safer.
 * It composes the id of specified item to the string.
 * Usage:
 * - Compose the id, eg:
 *  const id = IdUtils.composeId({ item: 'folder', id: folder.id });
 *
 * It's easy to extend the data types by adding new types to the UniqueItem union type.
 */

export const SEPARATOR = '-';

export const UNIQUE_ITEMS = ['folder', 'issue'] as const;
export type UniqueItem = typeof UNIQUE_ITEMS[number];

export type ComposedId = `${UniqueItem}${typeof SEPARATOR}${number}`;
export type DecomposedId = { item: UniqueItem; id: number };

export const isUniqueItem = (value: any): value is UniqueItem => {
  return UNIQUE_ITEMS.includes(value);
};

export const composeId = ({ item, id }: DecomposedId): ComposedId => {
  if (isUniqueItem(item)) {
    if (!id || isNaN(Number(id))) {
      throw new Error(`Invalid id: ${id}`);
    }

    return `${item}${SEPARATOR}${id}`;
  }

  throw new Error(`Invalid item: ${item}`);
};

export const IdUtils = {
  composeId,
};
